import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    id: 0,
    name: ""
}

export const usersGroupSlice = createSlice({
    name: 'usersGroup',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            else {
                state = {
                    ...state, 
                    ...payload.payload
                };
            }
            return state;
        }
    },
})

export const { edit } = usersGroupSlice.actions

export default usersGroupSlice.reducer